import { finalize } from "rxjs/operators";

editOptinListController.$inject = ['$scope',
  '$mdDialog',
  'AngularOptinsService',
  'AlertingFactory',
  'context',
  'elementData'];
export function editOptinListController($scope,
  $mdDialog,
  AngularOptinsService,
  AlertingFactory,
  context,
  elementData) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.elementData = elementData;

  init();

  function ok() {
    $scope.dropdownItems.forEach(optin => {
      if (optin.id === $scope.elementData.id) {
        // Store label, to be displayed it in the bobox
        $scope.elementData.label = optin.label;
      }
    })
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function buildDropdownOptinItems(optins) {
    return optins.map(optin => ({
      id: optin.id,
      label: optin.name,
    }));
  }

  function init() {
    $scope.loading = true;
    AngularOptinsService.getOptins()
      .pipe(finalize(() => $scope.loading = false))
      .subscribe({
        next: res => {
          $scope.dropdownItems = buildDropdownOptinItems(res);
        }
      })
  }
}
